import React from 'react';

const Error403PageConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/error-403',
      component: React.lazy(() => import('./Error403Page'))
    }
  ]
};

export default Error403PageConfig;
